import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

export const SubPageLayout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="subpage-layout">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
            data-testid="subpage-logo-home"
          >
            <img src="/logo.png" alt="Smart Post Solution" className="h-14" />
            <span className="text-lg font-semibold text-slate-800">Smart Post Solution</span>
          </Link>
          <Link
            to="/"
            className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
            data-testid="subpage-back-home"
          >
            Zur Startseite
          </Link>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default SubPageLayout;
